import React from 'react';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes/AppRoutes';
import Theme from './Theme.config';
import { ThemeProvider, CssBaseline } from '@mui/material';
import IdleSessionHandler from './components/common/IdleSessionHandler';
import ScreenRecorderOverlay from './components/common/ScreenRecorderOverlay';
import { ScreenRecorderPlacementProvider } from './components/common/ScreenRecorderPlacement';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        {/* Global Idle Session Handler - Shows dialog after 30 min of inactivity */}
        <IdleSessionHandler />
        <ScreenRecorderPlacementProvider>
        <AppRoutes />
        {/* Floating recording controls, visible on every screen (with or without navbar) */}
        <ScreenRecorderOverlay />
        </ScreenRecorderPlacementProvider>
        <Toaster position="top-right" />
      </ThemeProvider>
    </div>
  );
}

export default App;